/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Silotemperature1Inputs */



/**
* | output |
* | --- |
* | "Silo temperature" |
*
* @param {Br_History_Key_Silotemperature1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_silotemperature1 = /** @type {((inputs?: Br_History_Key_Silotemperature1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Silotemperature1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Silo temperature")
	return /** @type {LocalizedString} */ ("Température du silo")
});
export { br_history_key_silotemperature1 as "br_history_key_siloTemperature" }